import type { Event } from '@/types/event';

export const imageSrc = (event: Event, width:number = 600, height:number = 400): string => 
  event.image ||
  event.next_schedule?.thumbnail_url ||
  `https://placehold.co/${width}x${height}/ff7f00/white?text=${encodeURIComponent(event.title || 'Event')}`;

export const avatar = (prof: any, count: number = 0): string => {
  const randomAvatar = `https://picsum.photos/200?random=${prof.id + Math.random()}`;
  return count < 5 ? prof.profile_picture || randomAvatar : randomAvatar;
};

export const getEarliestEventDate = (events: Event[]): Date | null => {
  if (!events?.length) return null;

  const validDates = events
    .map((e) => {
      const scheduleAt = e.next_schedule?.schedule_at ?? e.event_date;
      return scheduleAt ? new Date(scheduleAt) : null;
    })
    .filter((d): d is Date => !!d && !isNaN(d.getTime()));

  if (!validDates.length) return null;
  return new Date(Math.min(...validDates.map((d) => d.getTime())));
};